<script setup lang="ts">
defineProps<{
  on: boolean
  spaced?: boolean
  click: (() => void) | undefined
  radius?: boolean
  height?: '_hm34' | '_hm44'
}>()
</script>

<template>
  <button type="button" :class="[$style.select, on && $style.on, radius && '_br9 _hidden', height || '_hm44']" @click.passive="() => click?.()" @keypress.passive.enter="() => click?.()">
    <span v-bind="$attrs" class="_relative _w100p _row _ctrY _gap2" :class="spaced && '_spaced'"><slot /></span>
  </button>
</template>

<style module>
.select {
  --r: 14px;
  composes: global(_relative);
  composes: global(_block);
  composes: global(_fw-l);

  composes: global(_w100p);

  composes: global(_pt04);
  composes: global(_pb04);

  composes: global(_pl1);
  composes: global(_pr08);

  border: 0;
  appearance: auto;
  text-align: left;
  appearance: auto;
  cursor: pointer;
}

.select em {
  font-size: var(--fs-08);
  color: var(--black-4);
  font-weight: var(--fw-m);
}

.select:hover {
  color: var(--bg);
}
.on {
  background: var(--blue3);
  composes: global(_c0);
}

.select::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  border-radius: var(--r);
  clip-path: inset(calc(100% - 7px) 7px 7px 7px round var(--r));
  transition: clip-path 0.45s cubic-bezier(0.23, 1, 0.32, 1);
  background: var(--blue3);
  z-index: 0;
}

.select:hover::before,
.on::before {
  --r: 0px;
  clip-path: inset(0 0 0 0 round var(--r));
}
</style>
